import React, {useState} from 'react'
import {message, Popconfirm} from "antd";
import {deleteContactList} from "../../../../services/api/apiSwagger";
import parseToken from "../../../../helpers/parseToken";

const DeleteContactForm = (props) => {
    const {arrSelected, fetchListContact, onClearChecked} = props
    const [loading, setLoading] = useState(false)

    const _onChangeStatus = async () => {
        setLoading(true)
        const info = parseToken()
        try {
            const payload = {
                contactListIds: arrSelected
            }

            const response = await deleteContactList(info.sub, payload)

            const {success, message: error} = response

            if (parseInt(success) !== 1) {
                setLoading(false)
                return message.error(error)
            }

            setLoading(false)
            fetchListContact()
            onClearChecked()
            message.success('Xóa danh sách thành công!')
        } catch (e) {
            setLoading(false)
            message.error(e.message)
        }
    }

    const _confirmDelete = () => {
        return <span>Bạn chắc chắn muốn xóa danh sách?<br/>(Danh sách bị xóa cũng sẽ được loại bỏ ở chiến dịch đã được gán)</span>
    }

    return <>
        <Popconfirm placement="bottomRight" title={_confirmDelete} onConfirm={_onChangeStatus} okText="Có"
                    cancelText="Không">
            <button disabled={loading} className="ButtonCustom ml-3">Xóa danh sách</button>
        </Popconfirm>
    </>
}

export default DeleteContactForm
